"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var HoverLine = function HoverLine(_ref) {
  var _ref$invert = _ref.invert,
      invert = _ref$invert === void 0 ? false : _ref$invert,
      _ref$bottom = _ref.bottom,
      bottom = _ref$bottom === void 0 ? false : _ref$bottom,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "rgba(75, 86, 84, 0.88" : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "0.2" : _ref$size,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? "absolute" : _ref$position,
      show = _ref.show;

  var _useState = (0, _react.useState)({
    width: "0",
    height: "0"
  }),
      _useState2 = _slicedToArray(_useState, 2),
      dimensions = _useState2[0],
      setDimensions = _useState2[1];

  var hoverLineStyle = {
    display: "flex",
    width: show ? "".concat(dimensions.width, "px") : "00%",
    height: "".concat(size, "rem"),
    alignSelf: bottom ? "flex-end" : "flex-start",
    transition: "all 0.7s",
    backgroundColor: color,
    opacity: show ? "1" : "0",
    position: position
  };
  var stageCanvasRef = (0, _react.useRef)(null); // useEffect will run on stageCanvasRef value assignment

  (0, _react.useEffect)(function () {
    if (stageCanvasRef.current) {
      var width = stageCanvasRef.current.parentNode.offsetWidth;
      var height = stageCanvasRef.current.parentNode.offsetHeight;
      setDimensions({
        width: width,
        height: height
      });
    }
  }, [stageCanvasRef]);
  return /*#__PURE__*/_react["default"].createElement("span", {
    ref: stageCanvasRef,
    style: hoverLineStyle
  });
};

var _default = HoverLine;
exports["default"] = _default;

//# sourceMappingURL=index.js.map